import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export function useUserRole() {
  const { user } = useAuth();

  const { data: userRole, isLoading } = useQuery({
    queryKey: ['user-role', user?.id],
    queryFn: async () => {
      if (!user) return null;
      
      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id)
        .maybeSingle();
      
      if (error) throw error;
      return data?.role || null;
    },
    enabled: !!user,
  });

  const isAdmin = userRole === 'superadmin' || userRole === 'orgadmin';
  const isStaff = userRole === 'staff' || isAdmin;

  return {
    role: userRole,
    isAdmin,
    isStaff,
    isLoading,
  };
}
